import React from 'react';
import { LockIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { CtaButton } from './CtaButton';
import { TrustStrip } from './TrustStrip';
import { MAIN_MOCKUP, pricing } from '../data/unstuckContent';
export function FinalOfferSection() {
  return <section className="w-full border-t border-champagne/25 bg-black" aria-labelledby="final-title" data-id="element-66" data-mp="2nznq8bnm6qrk">
      <div className="mx-auto grid max-w-4xl items-center gap-8 px-5 py-12 sm:grid-cols-2 sm:gap-10 sm:py-16" data-id="element-67" data-mp="1qcfcj2tuum04">
        <img src={MAIN_MOCKUP} alt="The complete UNSTUCK system — six volumes and five strategic bonuses" className="mx-auto w-full max-w-[17rem]" width={1080} height={1080} data-id="element-68" data-mp="1vagufkfjofa0" />

        <div className="text-center sm:text-left" data-id="element-69" data-mp="252mk2nibqkm1">
          <CountdownTimer label="The price closes in" className="sm:text-left [&>div]:justify-center sm:[&>div]:justify-start" data-id="element-70" data-mp="17lxovcnvqglm" />

          <h2 id="final-title" className="mt-7 font-display text-[1.7rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.25rem]" data-id="element-71" data-mp="1cinzhkgx0jzn">
            Unstuck
          </h2>
          <p className="mt-2 text-[12px] uppercase tracking-[0.14em] text-body" data-id="element-72" data-mp="22s1tyau05e8k">
            6 Volumes + 5 Bonuses · Complete System
          </p>

          <p className="mt-5 border-t border-charcoal-600 pt-5 text-[12px] uppercase tracking-[0.12em] text-muted line-through" data-id="element-73" data-mp="1xs73g8e52qo1">
            {pricing.regularPrice}
          </p>
          <p className="mt-1 font-display text-6xl font-semibold leading-none text-ivory-50 sm:text-7xl" data-id="element-74" data-mp="1orqzkxthhhin">
            {pricing.today}
            <span className="ml-2 align-middle font-sans text-xs font-semibold uppercase tracking-[0.14em] text-muted" data-id="element-75" data-mp="1jtpi2hbphq9a">
              USD
            </span>
          </p>

          <div className="mt-6 flex justify-center sm:justify-start" data-id="element-76" data-mp="3e7grbfq4i847">
            <CtaButton target="checkout" size="md" label="I want my UNSTUCK now →" data-id="element-77" data-mp="39841qn7vamxx" />
          </div>
          <p className="mt-3 flex items-center justify-center gap-1.5 text-[10px] font-medium uppercase tracking-[0.14em] text-muted sm:justify-start" data-id="element-78" data-mp="17j80fvdlwc8n">
            <LockIcon className="h-3 w-3 text-champagne" strokeWidth={1.75} aria-hidden="true" data-id="element-79" data-mp="1cb96v0o3f8qr" />
            100% Secure payment
          </p>
          <TrustStrip variant="full" className="mt-3 sm:justify-start" data-id="element-80" data-mp="12jv48k0uhste" />
        </div>
      </div>
    </section>;
}